// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"430":"35c18e1d","641":"61a6341f","823":"1121677c"}[chunkId] + ".chunk.css";
};